import { Button } from '@/components/ui/button'
import type { CarrierSearchMatch } from '../../models/carrierSearch'

interface CarrierSearchResultsProps {
  carriers: CarrierSearchMatch[]
  hasMore: boolean
  onPick: (carrier: CarrierSearchMatch) => void
  readonly?: boolean
}

/** The company-name matches, one button each, the way the chat offers any choice. */
export function CarrierSearchResults({ carriers, hasMore, onPick, readonly }: CarrierSearchResultsProps) {
  if (carriers.length === 0) {
    return (
      <p className="text-muted-foreground text-right text-sm">
        No active carriers match that name. Try another spelling, or enter your DOT number.
      </p>
    )
  }

  return (
    <div className="flex flex-col items-end gap-2">
      {carriers.map((carrier) => (
        <Button
          key={carrier.dotNumber}
          type="button"
          variant="outline"
          className="h-auto max-w-full flex-col items-end gap-0.5 py-2 text-right whitespace-normal"
          onClick={() => onPick(carrier)}
          disabled={readonly}
        >
          <span>{carrier.legalName}</span>
          <span className="text-muted-foreground text-xs font-normal">{matchDetails(carrier)}</span>
        </Button>
      ))}
      {hasMore && (
        <p className="text-muted-foreground text-right text-xs">
          Showing the first {carriers.length}. Add more of the name to narrow it down.
        </p>
      )}
    </div>
  )
}

function matchDetails({ dbaName, city, state, dotNumber }: CarrierSearchMatch) {
  const place = [city, state].filter(Boolean).join(', ')
  return [dbaName && `DBA ${dbaName}`, place, `DOT ${dotNumber}`].filter(Boolean).join(' · ')
}
